import React from "react";
import "./FullScreenNavbar.css";
import { AiOutlineClose } from "react-icons/ai";
import logo from "../../images/logo_blue_full.png";
import { Link, useLocation } from "react-router-dom";
import { waMessages } from "../../Utils/waMessages";
import SaveTheWaves from "../../images/save_the_waves.png";
import { PiInstagramLogo, PiWhatsappLogo } from "react-icons/pi";

export const FullScreenNavbar = ({ closeNavbarMenu }) => {
  const location = useLocation();

  return (
    <div className="fullscreen-navbar">
      <button
        className="fullscreen-navbar__close"
        onClick={closeNavbarMenu}
        aria-label="Close Menu"
      >
        <AiOutlineClose
          size={30}
          color="black"
          className="fullscreen-navbar__close-icon"
        />
      </button>

      <Link to="/" onClick={closeNavbarMenu}>
        <img
          className="fullscreen-navbar__logo"
          alt="TIDE Surfing school"
          src={logo}
        />
      </Link>

      <Link
        className="fullscreen-navbar__image"
        to="https://www.savethewaves.org/puertoescondido/"
        target="_blank"
      >
        <img
          src={SaveTheWaves}
          className="fullscreen-navbar__save-the-waves-image"
          alt="Save The Waves Coallition"
        />
      </Link>

      <div className="fullscreen-navbar__content">
        <ul className="fullscreen-navbar__menu">
          <li className="fullscreen-navbar__item">
            <Link
              to="about-us"
              onClick={closeNavbarMenu}
              className={
                location.pathname === "/about-us"
                  ? "fullscreen-navbar__link active"
                  : "fullscreen-navbar__link"
              }
            >
              Nosotros
            </Link>
          </li>
          <li className="fullscreen-navbar__item">
            <Link
              to="activities"
              onClick={closeNavbarMenu}
              className={
                location.pathname === "/activities"
                  ? "fullscreen-navbar__link active"
                  : "fullscreen-navbar__link"
              }
            >
              Actividades
            </Link>
          </li>
          <li className="fullscreen-navbar__item">
            <Link
              to="gallery"
              onClick={closeNavbarMenu}
              className={
                location.pathname === "/gallery"
                  ? "fullscreen-navbar__link active"
                  : "fullscreen-navbar__link"
              }
            >
              Galeria
            </Link>
          </li>
        </ul>
      </div>

      <div className="fullscreen-navbar__icons">
        <ul className="fullscreen-navbar__menu horizontal">
          <li className="fullscreen-navbar__item">
            <a
              href="https://www.instagram.com/tide_surfpuertoescondido/"
              className="fullscreen-navbar__icon-link"
              rel="noopener noreferrer"
              target="_blank"
            >
              <PiInstagramLogo color="#65839D" size={25} />
            </a>
          </li>
          <li className="fullscreen-navbar__item">
            <a
              href={`https://wa.me/529541686583?text=${waMessages.general}`}
              className="fullscreen-navbar__icon-link"
              rel="noopener noreferrer"
              target="_blank"
            >
              <PiWhatsappLogo color="#65839D" size={25} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};
